var SNACKBAR_GAP = 50;
function getVisibleSnackbars(instance) {
    var host = instance.getContainerDom();
    host.__dui_visible_snackbars__ = host.__dui_visible_snackbars__ || [];
    return host.__dui_visible_snackbars__;
}
function getIndexOf(instance) {
    return getVisibleSnackbars(instance).findIndex(function (elem) { return elem.instance === instance; });
}
function findReplaceableSnackbar(newInstance) {
    var visibleSnackbars = getVisibleSnackbars(newInstance);
    var id = newInstance.props.id;
    if (id) {
        var sameIdIndex = visibleSnackbars.findIndex(function (elem) { return elem.instance.props.id === id; });
        if (sameIdIndex >= 0) {
            return visibleSnackbars[sameIdIndex];
        }
    }
    var autoCloseIndex = visibleSnackbars.findIndex(function (elem) { return elem.instance.props.autoClose; });
    if (autoCloseIndex >= 0) {
        return visibleSnackbars[autoCloseIndex];
    }
    return null;
}
function getNextMargin(newInstance) {
    var replacedSnackbar = findReplaceableSnackbar(newInstance);
    if (replacedSnackbar) {
        return replacedSnackbar.marginTop;
    }
    var occupiedMargins = getVisibleSnackbars(newInstance).map(function (elem) { return elem.marginTop; }).sort(function (a, b) { return a - b; });
    if (occupiedMargins.length === 0) {
        return 0;
    }
    for (var i = 0; i < occupiedMargins.length; i++) {
        var targetMargin = SNACKBAR_GAP * i;
        var occupiedMargin = occupiedMargins[i];
        if (targetMargin !== occupiedMargin) {
            return targetMargin;
        }
    }
    return occupiedMargins[occupiedMargins.length - 1] + SNACKBAR_GAP;
}
export function updateVisibleSnackbars(instance) {
    var visible = instance.props.visible;
    var index = getIndexOf(instance);
    var visibleSnackbars = getVisibleSnackbars(instance);
    if (visible && index === -1) {
        var replacedSnackbar = findReplaceableSnackbar(instance);
        replacedSnackbar === null || replacedSnackbar === void 0 ? void 0 : replacedSnackbar.instance.handleClose();
        visibleSnackbars.push({
            instance: instance,
            marginTop: getNextMargin(instance)
        });
    }
    if (!visible && index !== -1) {
        visibleSnackbars.splice(index, 1);
    }
}
export function getMarginTop(instance) {
    var index = getIndexOf(instance);
    var visibleSnackbars = getVisibleSnackbars(instance);
    return index !== -1 ? visibleSnackbars[index].marginTop : getNextMargin(instance);
}
export function closeAll(force) {
    var snackbars = document.body.__dui_visible_snackbars__;
    snackbars === null || snackbars === void 0 ? void 0 : snackbars.filter(function (_a) {
        var instance = _a.instance;
        var _b = instance.props, autoClose = _b.autoClose, closable = _b.closable;
        return force || autoClose || closable;
    }).forEach(function (item) { return item.instance.handleClose(); });
}
export function closeById(id) {
    var snackbars = document.body.__dui_visible_snackbars__;
    snackbars === null || snackbars === void 0 ? void 0 : snackbars.filter(function (_a) {
        var instance = _a.instance;
        return instance.props.id === id;
    }).forEach(function (item) { return item.instance.handleClose(); });
}
export function hasVisibleInstances() {
    var _a;
    return Boolean((_a = document.body.__dui_visible_snackbars__) === null || _a === void 0 ? void 0 : _a.length);
}
